/**
 * Daily times module
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.location.custom.times.daily');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const times = goog.require('yext.location.custom.times');
const holiday = goog.require('yext.location.custom.times.holiday');
const helpers = goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
const time = goog.require('yext.time');


var days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

/**
 * Represents a time within a daily time field
 * @constructor
 * @param {!Object} data DailyTime model properties for initialization
 */
function DailyTime(data) {
  times.Time.call(this, data);
}
goog.inherits(DailyTime, times.Time);

DailyTime.prototype.namespace = 'dailytime';
DailyTime.prototype.validProperties = ['day', 'unspecified', 'time'];

/**
 * Make an update to the model
 *
 * @param {!Object} data The update
 */
DailyTime.prototype.update = function(data) {
  if (typeof data !== 'undefined') {
    delete data.day; // Do not allow update to day
  }
  var changes = this.getChanges(data);

  if (changes) {
    if (changes.unspecified === true) {
      delete this.time;
      delete changes.time;
    } else if (changes.unspecified === false) {
      changes.time = '';
    }
    if (typeof changes.time != 'undefined') {
      delete this.unspecified;
      delete changes.unspecified;
    }
    $.extend(this, changes);
    this.broadcast(changes);
    $(this).trigger('update.list');
    $(this).trigger('update.struct');
  }
};

/**
 * DailyTimeUI class
 *
 * @constructor
 * @param {!Object} model The related DailyTime model
 * @param {!jQuery} $element The DOM element
 */
function DailyTimeUI(model, $element) {
  times.TimeUI.call(this, model, $element);
}
goog.inherits(DailyTimeUI, times.TimeUI);

/**
 * Get nested elements within $element
 */
DailyTimeUI.prototype.getElements = function() {
  this.$time = this.$element.find('.js-day-time');
  this.$unspecified = this.$element.find('.js-day-time-unspecified');
};

/**
 * Get model details from the DOM
 */
DailyTimeUI.prototype.modelFromElements = function() {
  if (this.$unspecified.prop('checked')) {
    this.model.unspecified = true;
  } else {
    this.model.time = this.$time.val();
  }
};

/**
 * Render the UI
 */
DailyTimeUI.prototype.render = function() {
  if (this.$time.val() !== this.model.time) {
    this.$time.val(this.model.time);
  }

  if (this.$unspecified.prop('checked') != this.model.unspecified) {
    this.$unspecified.prop('checked', !!this.model.unspecified);
  }

  if (this.$time.prop('disabled') != !!this.model.unspecified) {
    this.$time.prop('disabled', !!this.model.unspecified);
  }
};

/**
 * Bind DOM element change events to the model
 */
DailyTimeUI.prototype.dataBindings = function() {
  var self = this;

  this.$time.inputchange(function() {
    self.model.update({
      time: self.$time.val(),
    });
  }).blur(function() {
    self.model.update({
      time: times.formatTime(self.$time.val()),
    });
  });

  this.$unspecified.on('click change', function() {
    self.model.update({
      unspecified: self.$unspecified.prop('checked'),
    });
  });
};

/**
 * Daily Times field class
 *
 * @constructor
 * @param {!jQuery} $element Context for the daily times field
 */
function DailyTimesField($element) {
  this.$element = $element;
  this.$specifyTimes = $element.find('.js-specifiy-daily-times');
  this.$timesEditTable = $element.find('.js-times-edit-table');
  this.$timesMain = $element.find('.js-times-main');
  this.$resetTimesWrap = $element.find('.js-reset-times-wrap');

  this.indeterminate = !!this.$resetTimesWrap.data('indeterminate');
  this.fieldName = $element.find('input[name="field"]').val();
  this.timesSpecified = this.$specifyTimes.prop('checked');
  this.times = [];
  this.timesUI = {};

  this.build();
  this.storeValues();
  this.bindings();
  this.createHolidayDailyTimes();

  this.assetOrOriginal = true;
  this.originalValue = yext.JSON.stringify(this.storedValues);
}

/**
 * Store the values so they can be restored if the field is reset
 */
DailyTimesField.prototype.storeValues = function() {
  var times = [];
  this.times.forEach(function(time) {
    times.push(time.ownProperties());
  });

  this.storedValues = {
    timesSpecified: this.timesSpecified,
    times: times,
    indeterminate: this.indeterminate,
  };

  if (this.holidayTimes) {
    this.holidayTimes.storeValues();
  }
};

/**
 * Build UI and model classes from the DOM
 */
DailyTimesField.prototype.build = function() {
  var self = this;

  days.forEach(function(day) {
    var $element = self.$element.find('.js-day-time-' + day);
    var timeUI = new DailyTimeUI(new DailyTime({day: day}), $element);
    self.timesUI[day] = timeUI;
    self.times.push(timeUI.model);
    $(timeUI.model).on('updated.dailytime', function(e, update) {
      timeUI.render();
      self.broadcast('updated');
      $(self).trigger('update.list');
      $(self).trigger('update.struct');
      self.updateAssetOrOriginal(false);
    });
  });
};

/**
 * Do field wide data bindings
 */
DailyTimesField.prototype.bindings = function() {
  var self = this;

  this.$specifyTimes.on('click change', function() {
    self.timesSpecified = self.$specifyTimes.prop('checked');
    self.toggleTimesSpecified();
    self.broadcast('updated');
    $(self).trigger('update.list');
    $(self).trigger('update.struct');
  });

  this.$resetTimesWrap.find('.js-reset-times').click(function() {
    self.$resetTimesWrap.hide();
    self.$timesMain.show();
    self.indeterminate = false;
    self.$specifyTimes.prop('checked', true).trigger('change');
  });

  this.$element.find('.js-apply-to-all').click(function() {
    var monday = self.timesUI.MONDAY.model.ownProperties();
    days.slice('MONDAY').forEach(function(day) {
      var timeUI = self.timesUI[day];
      timeUI.model.update(monday);
      timeUI.render();
    });
  });
};

DailyTimesField.prototype.toggleTimesSpecified = function() {
  this.$timesEditTable.toggle(this.timesSpecified);
};

/**
 * Broadcast that a message about the field as a whole
 *
 * @param {string} message The type of message to send
 */
DailyTimesField.prototype.broadcast = function(message) {
  $(this).trigger(message + '.dailyTimes');
};

/**
 * Restore the field based upon the storedValues object
 */
DailyTimesField.prototype.reset = function() {
  this.reconcile(this.storedValues);
};

/**
 * Refresh the field based upon values passed
 *
 * @param {!Object} field Basic object that had daily times field properties
 */
DailyTimesField.prototype.reconcile = function(field) {
  var self = this;

  this.timesSpecified = field.timesSpecified;
  this.$specifyTimes.prop('checked', field.timesSpecified);
  this.toggleTimesSpecified();

  this.indeterminate = !!field.indeterminate;
  this.$resetTimesWrap.toggle(this.indeterminate);
  this.$timesMain.toggle(!this.indeterminate);

  // Reset to default state
  if (!field.times.length) {
    days.forEach(function(day) {
      field.times.push({
        day: day,
        time: '',
      });
    });
  }
  if (!this.indeterminate) {
    field.times.forEach(function(time) {
      var timeUI = self.timesUI[time.day];
      timeUI.model.update(time);
      timeUI.render();
    });
  }

  if (this.holidayTimes && field.holidayTimes) {
    this.holidayTimes.reconcile(field.holidayTimes);
  }
};

/**
 * Get details about the field in its current state
 *
 * @return {!Object} Details about the daily times field
 */
DailyTimesField.prototype.get = function() {
  var times = {};

  if (this.indeterminate) {
    times.indeterminate = true;
  } else if (this.timesSpecified) {
    times.times = this.times;
  }

  if (this.holidayTimes) {
    times.holidayTimes = this.holidayTimes.get();
  }

  return times;
};

/**
 * Get timestamp
 *
 * @return {string} Timestamp for times field
 */
DailyTimesField.prototype.getTimestamp = function() {
  return this.$element.find('.js-field-timestamp').val();
};

/**
 * Instantiate HolidayDailyTimes class if corresponding field is found
 */
DailyTimesField.prototype.createHolidayDailyTimes = function() {
  var $holidayTimes = times.findHolidayDailyTimes(this.fieldName);

  if ($holidayTimes.length) {
    this.holidayTimes = holiday.createHoliday($holidayTimes);
  }
};

/**
 * Generate view markup
 */
DailyTimesField.prototype.generateViewMarkup = function(cannotEdit) {
  if (this.indeterminate) {
    return helpers.variousContentMessage();
  }

  if (!this.timesSpecified) {
    return helpers.emptyFieldMessage(cannotEdit);
  }

  var self = this;
  var table = [];

  days.forEach(function(day) {
    var row = {
      label: time.dayAbbreviations[day],
    };

    if (self.timesUI[day].model.unspecified) {
      row.value = yext.msg('None');
    } else {
      row.value = self.timesUI[day].model.time;
    }

    table.push(row);
  });

  return times.buildTimesTable(table);
};

/**
 * Package relevant field info to send to a parent struct.
 */
DailyTimesField.prototype.getJSONData = function() {
  return {
    ['field']: this.fieldName,
    [this.fieldName + '.specified']: this.timesSpecified,
    [this.fieldName + '.timestamp']: this.getTimestamp(),
    ['indeterminate']: this.indeterminate,
    ['times']: this.times,
  };
};

/**
 * The after save function when this field is a child of a struct.
 */
DailyTimesField.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate /* unused */, cannotEdit) {
  this.reconcile(fieldValues);
  this.storeValues();
  $display.empty().append(this.generateViewMarkup(cannotEdit));

  this.assetOrOriginal = true;
  this.originalValue = yext.JSON.stringify(this.storedValues);
};

/**
 * clear field
 */
DailyTimesField.prototype.clear = function() {
  var self = this;

  this.timesSpecified = false;
  this.$specifyTimes.prop('checked', false);
  this.toggleTimesSpecified();

  this.indeterminate = false;
  this.$resetTimesWrap.toggle(false);
  this.$timesMain.toggle(true);

  days.forEach(function(day) {
    var timeUI = self.timesUI[day];
    timeUI.model.update({day: day, time: ''});
    timeUI.render();
  });
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
DailyTimesField.prototype.applyAsset = function(fieldValues) {
  this.reconcile(fieldValues);
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
DailyTimesField.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === yext.JSON.stringify(this.storedValues)) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
DailyTimesField.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * Create a new DailyTimesField object
 *
 * @param {!jQuery} $element The containing UI element for a daily times field
 * @return {!DailyTimesField} Instance of a daily times field
 */
function create($element) {
  return new DailyTimesField($element);
}

exports = {
  DailyTime,
  DailyTimeUI,
  DailyTimesField,
  create,
};
